<div class="ui container-home">
  <div class="ui grid responsive-grid" style="display: flex; flex-wrap: nowrap; width: 100%;">
    <div class="column content-fit" style="flex: 0 0 auto; width: auto; min-width: max-content;">
      <div class="ui card filter" id='card-filter' style='background-color:rgb(249, 249, 249);'>
        <div class="content">
          <div class=" ui left floated header">Filtros
            <i class="filter icon light-blue"></i>
          </div>

        </div>

        <div class="content">
          <form [formGroup]="formDatos" id='form' class="ui form">

            <div class="field">

              <app-select-filter label="Categoria" formName="category" [filters]="categoryFilters"
                (changeCheck)="setForm($event)" [selectedOption]="formDatos.get('category')?.value"></app-select-filter>
            </div>

            <div class="field">
              <app-select-filter label="Protocolo" formName="protocol" [filters]="protocolFilters"
                (changeCheck)="setForm($event)" [selectedOption]="formDatos.get('protocol')?.value"></app-select-filter>
            </div>
            <div class="field">
              <app-select-filter label="Mision" formName="mision" [filters]="misionFilters"
                (changeCheck)="setForm($event)" [selectedOption]="formDatos.get('mision')?.value"></app-select-filter>
            </div>
            <div class="field">
              <label class='label light-blue'>Estado</label>
              <div class="ui input">
                <select class="ui selection dropdown secciones" formControlName="state">
                  <option value="">Seleccione:Estado</option>
                  <option *ngFor='let n of stateFilters' [value]="n">{{n}}</option>
                </select>
              </div>
            </div>

            <div class="field">
              <label class='label light-blue'>Fecha Desde</label>
              <div class="ui input" color="accent" appearance="outline">
                <input formControlName="dateFrom" type='date' placeholder="29/03/2017">
              </div>

            </div>
            <div class="field">
              <label class='label light-blue'>Fecha Hasta</label>

              <div class="ui input" color="accent" appearance="outline">
                <input formControlName="dateUntil" type='date' placeholder="29/03/2017">
              </div>
            </div>



          </form>
        </div>
        <div class="extra content">
          <button class="ui right labeled icon button button-filter primary" [disabled]='formDatos.invalid'
            (click)="aplicar()">
            <i class=" check icon"></i>
            APLICAR
          </button>
          <button class="ui right labeled icon button button-filter primary" (click)="limpiar()">
            <i class="trash alternate
                        icon"></i>
            LIMPIAR
          </button>
        </div>
      </div>
    </div>
    <div class="column content-fill" style="flex: 1 1 auto; display: flex; justify-content: center !important; flex-direction: column;">
      <div class="ui warning message" *ngIf='listRegistros.length === 0 && !spinner  '>
        <i class="close icon"></i>
        <div class="header">
          No se encontraron registros
        </div>
      </div>
      <div class="scroll">
        <table style='margin:auto;' class="ui celled selectable table" *ngIf=' listRegistros.length> 0'>
          <thead>
            <tr>

              <th class="center aligned">Categoria</th>
              <th class="center aligned">Protocolo</th>
              <th class="center aligned">Mision</th>
              <th class="center aligned">Estado</th>
              <th class="center aligned">Fecha
                <i (click)="changeOrder('down')" *ngIf="filtros.orderWhen!='down'" class="caret down icon pointer"></i>
                <i (click)="changeOrder('up')" *ngIf="filtros.orderWhen!='up'" class="caret up icon pointer"></i>
              </th>

              <th class="center aligned"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor='let item of listRegistros;index as index ;'>

              <td class="center aligned">
                {{item.Protocol_Categories}}
              </td>
              <td class="center aligned">
                <p>
                  {{item.Protocol_Id}}
                </p>
              </td>
              <td class="center aligned">
                <p>
                  {{item.Mission_Dsc}}
                </p>
              </td>
              <td class="center aligned">
                <p>
                  {{item.state}}
                </p>
              </td>
              <td class="center aligned">
                {{item.When | date: 'dd/MM/yyyy' }}
              </td>

              <td class="center aligned">
                <div class="ui vertical animated button" tabindex="0" (click)="detalle(item)">
                  <div class="hidden content">Ver </div>
                  <div class="visible content">
                    <i class="arrow right icon"></i>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="ui grid" *ngIf='pages_total >0 '>
        <div class="column centered row paginacion">
          <app-paginator #paginacion [pages_total]='pages_total' (eventEmmiterChangePage)='changePage($event)'>
          </app-paginator>
        </div>
      </div>
    </div>
  </div>
</div>